import { Route } from '@angular/router';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

export const aroundTheClockLocalGameRoutes: Route[] = [
    {
        path: 'local-games/around-the-clock',
        loadComponent: () =>
            import('./pages/around-the-clock-new-game/around-the-clock-new-game.component').then(
                (c) => c.AroundTheClockNewGameComponent
            ),
    },
    {
        path: 'game/around-the-clock',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/around-the-clock-local-game-app/around-the-clock-local-game-app.component').then(
                (m) => m.AroundTheClockLocalGameAppComponent
            ),
    },
];

export const aroundTheClockVenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/around-the-clock',
        loadComponent: () =>
            import('./pages/around-the-clock-new-game/around-the-clock-new-game.component').then(
                (c) => c.AroundTheClockNewGameComponent
            ),
    },
    {
        path: 'game/around-the-clock',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/around-the-clock-local-game-venue/around-the-clock-local-game-venue.component').then(
                (m) => m.AroundTheClockLocalGameVenueComponent
            ),
    },
];
